module.exports = __webpack_public_path__ + "img/vlogo-white.f89d25e7.png";